"use client";
import { useEffect, useState } from "react";

const languages = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
  { code: "pt", name: "Português", flag: "🇵🇹" },
  { code: "ru", name: "Русский", flag: "🇷🇺" },
  { code: "zh-CN", name: "中文", flag: "🇨🇳" },
  { code: "ja", name: "日本語", flag: "🇯🇵" },
];

export default function TranslatorWidget() {
  const [currentLang, setCurrentLang] = useState("en");

  useEffect(() => {
    const userLang = navigator.language || "en";
    const match =
      languages.find((l) => l.code === userLang) ||
      languages.find((l) => l.code.startsWith(userLang.split("-")[0])) ||
      languages[0];
    setCurrentLang(match.code);
  }, []);

  const translatePage = (lang) => {
    const translateUrl = `https://translate.google.com/translate?sl=auto&tl=${lang}&u=${window.location.href}`;
    window.location.href = translateUrl;
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "70px",
        left: "10px",
        zIndex: 999,
        background: "rgba(30, 30, 30, 0.85)",
        height:"45px",
        borderRadius: "7px",
        // padding: "6px 4px",
        // boxShadow: "0 0 12px rgba(0,0,0,0.3)",
        color: "#fff",
        // backdropFilter: "blur(6px)",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <select
        value={currentLang}
        onChange={(e) => {
          setCurrentLang(e.target.value);
          translatePage(e.target.value);
        }}
        style={{
          fontSize: "14px",
          fontWeight: 500,
          background: "transparent",
          color: "#f4f4f4",
          border: "none",
          outline: "none",
          cursor: "pointer",
          appearance: "none",
          padding: "none",
          paddingRight: "0px",
        }}
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code} style={{ color: "#000" }}>
            {lang.flag} {lang.code.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
}